export enum CaseTabs {
  Description = 0,
  Communication = 1,
  Files = 2,
  Workflow = 3,
  Notes = 4,
}
